<template>
  <PageTemplate>
    <h1>Notifications</h1>
    <v-tabs>
      <v-tab
        name="Send Notification"
        :selected="true"
      >
        <div class="row">
          <div class="col-md-8">
            <div class="row">
              <div class="col-lg-6">
                <v-fieldset
                  v-model="notification.sender_name"
                  :type="isPreview ? 'display' : 'text'"
                  text="Sender’s Full Name"
                />
              </div>
              <div class="col-lg-6">
                <v-fieldset
                  v-model="notification.sender_email"
                  :type="isPreview ? 'display' : 'text'"
                  text="Sender’s Email"
                />
              </div>
            </div>
            <v-fieldset
              v-model="notification.notification_title"
              :type="isPreview ? 'display' : 'textarea'"
              text="Notification Title"
            />
            <v-fieldset
              v-model="notification.notification_body"
              :type="isPreview ? 'display' : 'textarea'"
              text="Notification Body"
            />
          </div>
        </div>

        <fieldset class="fieldset">
          <v-label text="Send Notification to" />
          <v-checkbox-list
            v-if="!isPreview"
            id="group"
            v-model="selectedGroups"
            :groups="groups"
          />
          <v-list
            v-else
            :items="selectedGroups"
          />
        </fieldset>
        <v-button-group v-if="isPreview">
          <v-button
            size="lg"
            has-min-width
            @click="sendNotification"
          >
            Send
          </v-button>
          <v-button
            size="lg"
            color="secondary"
            has-min-width
            @click="isPreview = false"
          >
            Edit
          </v-button>
        </v-button-group>

        <v-button-group v-else>
          <v-button
            size="lg"
            has-min-width
            @click="isPreview = true"
          >
            Preview
          </v-button>
          <v-button
            size="lg"
            color="secondary"
            has-min-width
            @click="cancelNotification"
          >
            Cancel
          </v-button>
        </v-button-group>
      </v-tab>
      <v-tab name="Past Notifications">
        <h5>FILTER BY</h5>
        <fieldset class="fieldset">
          <v-label text="Keywords" />
          <v-input-wrap prefix="search">
            <v-input
              type="search"
              @input="filter"
            />
          </v-input-wrap>
        </fieldset>
        <v-notification
          v-for="notification in pastNotifications"
          :key="notification.id"
          :title="notification.title"
          :body="notification.body"
          type="System Admin"
          is-admin
          :date="formatDate(notification.date)"
          :recipient="notification.recipient"
          :sender="notification.sender"
        />
        <v-pagination
          v-if="!searchMode"
          :initial-current-page="page"
          :initial-rows-per-page="perPage"
          :count="total"
          :page-changed="pageChanged"
          :per-page-changed="perPageChanged"
        />
      </v-tab>
    </v-tabs>

    <v-modal
      v-if="cancelModal"
      @close="closeModal"
    >
      <template #header>
        Confirmation
      </template>
      Cancelling will reset all fields to default. <br>
      Do you want to continue?
      <template #footer>
        <v-button-group is-right>
          <v-button
            size="lg"
            has-min-width
            @click="clearForm"
          >
            Yes, continue
          </v-button>
          <v-button
            color="secondary"
            size="lg"
            has-min-width
            @click="closeModal"
          >
            Cancel
          </v-button>
        </v-button-group>
      </template>
    </v-modal>

    <v-modal
      v-if="successModal"
      @close="closeModal"
    >
      <template #header>
        Success
      </template>
      <strong>We have successfully sent notifications to following groups:</strong>
      <v-list
        :items="selectedGroups"
      />
      <template #footer>
        <v-button-group is-right>
          <v-button
            size="lg"
            has-min-width
            @click="finish"
          >
            Got it
          </v-button>
        </v-button-group>
      </template>
    </v-modal>
  </PageTemplate>
</template>
<script>
  import PageTemplate from "@/templates/Page";
  import Tabs from "@/molecules/Tabs";
  import Tab from "@/atoms/Tab";
  import List from "@/molecules/List";
  import Modal from "@/atoms/Modal";
  import Button from "@/atoms/Button";
  import CheckboxList from "@/molecules/CheckboxList";
  import ButtonGroup from "@/molecules/ButtonGroup";
  import Fieldset from "@/molecules/Fieldset";
  import Label from "@/atoms/Label";
  import InputWithIcon from "@/molecules/InputWithIcon";
  import Notification from "@/molecules/Notification";
  import Pagination from "@/molecules/Pagination";
  import Input from "@/atoms/Input";
  import {mapState} from "vuex";
  import { buildBreadCrumb } from "@/common/tableFunctions";
  import { formatDate } from "@/common/formatting";
  import constants from "@/common/constants";
  import {
    GET_COMMITTEES,
    GET_PAST_NOTIFICATION,
    SEND_ADMIN_NOTIFICATION,
    SEND_NOTIFICATION
  } from "../../store/actions.type";

  export default {
    name: "Users",
    components: {
      "v-tab": Tab,
      "v-tabs": Tabs,
      "v-button-group": ButtonGroup,
      "v-button": Button,
      "v-modal": Modal,
      "v-label": Label,
      "v-fieldset": Fieldset,
      "v-list": List,
      "v-input": Input,
      "v-pagination": Pagination,
      "v-input-wrap": InputWithIcon,
      "v-checkbox-list": CheckboxList,
      "v-notification": Notification,
      PageTemplate
    },
    data: () => ({
      notification: {
        type: 'admin',
        sender_name: '',
        sender_email: '',
        notification_title: '',
        notification_body: '',
        send_to: []
      },
      cancelModal: false,
      successModal: false,
      isPreview: false,
      groups: [
        {
          id: constants.NATA_ROLE_AR,
          value: 'Authorised Representative',
          items: []
        },
        {
          id: constants.NATA_ROLE_TA,
          value: 'Technical Assessor',
          items: []
        },
        {
          id: constants.NATA_ROLE_CM,
          value: 'Committee Members from the following Committees',
          items: []
        }
      ],
      selectedGroups: [],
      committees: [],
      selectedCommittees: [],
      isReady: false,
      searchKeyword: "",
      searchMode: false
    }),
    computed: {
      ...mapState({
        user: state => state.auth.user,
        pastNotifications: state => state.notification.admin.currentNotifications,
        total: state => state.notification.admin.total,
        page: state => state.notification.admin.page,
        perPage: state => state.notification.admin.perPage,
      })
    },
    watch:{
      user:{
        handler(val){
          this.notification.sender_name = val.first_name + ' ' + val.last_name;
          this.notification.sender_email = val.email;
        }
      }
    },
    mounted() {
      this.updateBreadCrumb();
      this.getPastNotifications();
      this.getCommittee();
      this.notification.sender_name = this.user.first_name + ' ' + this.user.last_name;
      this.notification.sender_email = this.user.email;
    },
    methods: {
      updateBreadCrumb: function () {
        let breadcrumbs = [];
        breadcrumbs['Notifications'] = '';
        this.breadcrumbs = buildBreadCrumb(breadcrumbs);
        this.$store.dispatch('updateBreadCrumbAction', buildBreadCrumb(breadcrumbs));
      },
      closeModal() {
        this.cancelModal = false;
        this.successModal = false;
      },
      finish() {
        this.notification.notification_title = '';
        this.notification.notification_body = '';
        this.selectedGroups = [];
        this.isPreview = false;
        this.cancelModal = false;
        this.successModal = false;
      },
      cancelNotification() {
        this.cancelModal = true;
      },
      sendNotification() {
        this.notification.send_to = this.selectedGroups
        this.validateNotification();
        if (this.isReady) {
          this.$store.dispatch(SEND_NOTIFICATION, this.notification)
            .then(response => {
              this.getPastNotifications();
              this.successModal = true;
            })
            .catch(error => {
              this.$notify({
                title: 'Error:',
                text: 'Send notification goes wrong!',
                type: 'error'
              })
            })
        }
      },
      validateNotification() {
        this.isReady = false;
        if (this.notification.notification_body.length == 0
          || this.notification.notification_title.length == 0
          || this.notification.sender_email.length == 0
          || this.notification.sender_name.length == 0
        ) {
          this.$notify({
            title: 'Error:',
            text: 'Sender email/full name and notification title/body cannot be empty!',
            type: 'error'
          })
        } else if (this.selectedGroups.length == 0) {
          this.$notify({
            title: 'Error:',
            text: 'At least 1 group should be selected!',
            type: 'error'
          })
        } else {
          this.isReady = true;
        }
      },
      clearForm() {
        this.notification.notification_title = '';
        this.notification.notification_body = '';
        this.selectedGroups = [];
        this.closeModal();
      },
      getCommittee() {
        this.$store.dispatch(GET_COMMITTEES)
          .then(response => {
            if (response.success) {
              this.groups[2].items = response.data.map(function (el) {
                return Object.keys(el)
                  .reduce((obj, key) => {
                    obj[key] = el[key];
                    return obj;
                  }, {});
              });
            }
          });
      },
      getPastNotifications() {
        /**
         * Get notifications sent by current admin
         */
        this.$store.dispatch(GET_PAST_NOTIFICATION);
      },
      filter(searchTerm) {
        this.searchKeyword = searchTerm.trim().replace(/\s+/g, " ");
        if (this.searchKeyword.length > 0) {
          this.searchMode = true;
          let res = this.$store.state.notification.admin.notifications.filter(ele => {
            let str = [
              JSON.stringify(ele),
            ];
            return this.searchKeyword.split(" ").some(
              r =>
                str
                  .join()
                  .toLowerCase()
                  .indexOf(r.toLowerCase()) != -1
            );
          })
          this.$store.state.notification.admin.currentNotifications = res;
        } else {
          this.searchMode = false;
          this.getPastNotifications();
        }
      },
      formatDate(datetime) {
        return formatDate(datetime);
      },
      pageChanged: function (page) {
        if (page.currentPage > 0) {
          this.$store.dispatch("updatePastNotificationsPage", page.currentPage);
        }
      },
      perPageChanged: function (perPage) {
        if (perPage.currentPerPage > 0) {
          this.$store.dispatch("updatePastNotificationsPerPage", perPage.currentPerPage);
        }
      },
    }
  }
</script>
